import { render, staticRenderFns } from "./SupplierOrders.vue?vue&type=template&id=20ede9d4&scoped=true&"
import script from "./SupplierOrders.vue?vue&type=script&lang=js&"
export * from "./SupplierOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ede9d4",
  null
  
)

export default component.exports